module.exports = __webpack_public_path__ + "static/img/shh4.15d7901.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/shh4.jpg
// module id = gWxW
// module chunks = 1